import React, { useState, useEffect, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { userService } from "../../../_services";
import AddEditTrainingModule from './AddEditModule';
import SortVideos from './SortVideos';
import SortModules from './SortModules';
import TrainingModule from './TrainingModule';
import PricingSheetModule from './PricingSheetModule';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowUpDown, Plus, Loader2 } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

function AdminTraining() {
    const [userId, setUserId] = useState('');
    const [userName, setUserName] = useState('');
    const [showModulePopup, setShowModulePopup] = useState(false);
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [moduleListPopup, setModuleListPopup] = useState(false);
    const [trainingModuleData, setTrainingModuleData] = useState([]);
    const [moduleEditMode, setModuleEditMode] = useState(false);
    const [moduleEditData, setModuleEditData] = useState({});
    const [deleteVideoLoader, setDeleteVideoLoader] = useState(false);
    const [moduleLoader, setModuleLoader] = useState(true);
    const [deletePopup, setDeletePopup] = useState(false);
    const [moduleId, setModuleId] = useState('');
    const [deleteModuleSuccessMsg, setDeleteModuleSuccessMsg] = useState('');
    const [orderModuleData, setOrderModuleData] = useState([]);

    const getTrainingModules = useCallback((uid, uname) => {
        setTrainingModuleData([]);
        setModuleLoader(true);
        try {
            userService.TrainingMedia(uid, uname, '').then(apiData => {
                if (apiData && apiData.length > 0 && apiData[0].modules) {
                    setTrainingModuleData(apiData[0].modules);
                    setOrderModuleData(apiData[0].modules);
                }
                setModuleLoader(false);
            }).catch(err => {
                console.error('Error fetching training modules:', err);
                setModuleLoader(false);
            });
        } catch (err) {
            console.error('Error in getTrainingModules:', err);
            setModuleLoader(false);
        }
    }, []);

    useEffect(() => {
        const usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const uid = Usermeta_Data.split(':')[0];
        const uname = Usermeta_Data.split(':')[1];
        setUserId(uid);
        setUserName(uname);
        getTrainingModules(uid, uname);
    }, [getTrainingModules]);

    const deleteModule = (moduleid) => {
        setDeleteVideoLoader(true);
        try {
            userService.DeleteModule(moduleid).then(response => {
                setDeleteVideoLoader(false);
                if (response.length > 0 && response[0].code === '1') {
                    getTrainingModules(userId, userName);
                    setDeleteModuleSuccessMsg(response[0].message);
                }
                setTimeout(() => {
                    setDeleteVideoLoader(false);
                    setDeletePopup(false);
                }, 1500);
            });
        } catch (err) {
            console.error('Error deleting module:', err);
            setDeleteVideoLoader(false);
            setDeletePopup(false);
        }
    };

    const editModule = (isEditing, mData) => {
        if (isEditing) {
            setModuleEditMode(isEditing);
            setModuleEditData(mData);
            setShowModulePopup(true);
        }
    };

    const orderVideoList = (mData) => {
        setModuleEditData(mData);
        setShowVideoPopup(true);
    };

    const changeInModule = () => getTrainingModules(userId, userName);
    const changeInVideo = () => getTrainingModules(userId, userName);

    // Only close the popup � data refresh is handled by renderVideos()
    // which is called by SortVideos/SortModules only after a successful save.
    const hideVideoPopup = () => setShowVideoPopup(false);
    const hideModulePopup = () => setModuleListPopup(false);

    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) {
        return <Navigate replace to="/signup" />;
    }
    localStorage.setItem('pagename', 'trainingpageadmin');

    return (window.atob(localStorage.getItem('UserRole')) === "Admin" ?
        <div className="w-full space-y-6">
            <div className="flex flex-wrap items-center justify-between gap-y-3 gap-x-4">
                <div className="flex items-center gap-3">
                    <h1 className="text-3xl font-bold tracking-tight text-foreground">Training</h1>
                </div>
                <div className="flex flex-wrap items-center gap-3">
                    {orderModuleData.length > 1 && trainingModuleData.length > 0 && (
                        <Button onClick={() => setModuleListPopup(true)} variant="secondary">
                            <ArrowUpDown className="h-4 w-4 mr-2" />
                            Reorder Module
                        </Button>
                    )}
                    {trainingModuleData.length > 0 && (
                        <Button onClick={() => setShowModulePopup(true)} variant="secondary">
                            <Plus className="h-4 w-4 mr-2" />
                            Add Training Module
                        </Button>
                    )}
                </div>
            </div>

            {moduleLoader && (
                <Card>
                    <CardContent className="flex items-center justify-center py-12">
                        <Loader2 className="h-12 w-12 animate-spin text-accent" />
                    </CardContent>
                </Card>
            )}

            {!moduleLoader && trainingModuleData.length > 0 && (
                <div className="space-y-6">
                    {trainingModuleData.map((item, index) => (
                        <TrainingModule
                            key={index}
                            moduleData={item}
                            orderVideoList={orderVideoList}
                            editModule={editModule}
                            deleteModule={(mid) => { setDeleteModuleSuccessMsg(''); setDeletePopup(true); setModuleId(mid); }}
                            changeInModule={changeInModule}
                            changeInVideo={changeInVideo}
                            videoDeleted={changeInVideo}
                        />
                    ))}
                </div>
            )}

            {!moduleLoader && trainingModuleData.length === 0 && (
                <Card className="border-border bg-card">
                    <CardContent className="flex flex-col items-center justify-center py-12">
                        <h3 className="text-xl font-semibold text-primary mb-2">No modules added yet!</h3>
                        <p className="text-sm text-muted-foreground mb-6">Please create a module for training</p>
                        <Button onClick={() => setShowModulePopup(true)} variant="secondary">
                            <Plus className="h-4 w-4 mr-2" />
                            Add Training Module
                        </Button>
                    </CardContent>
                </Card>
            )}

            <PricingSheetModule />

            {showModulePopup && (
                <AddEditTrainingModule
                    hideModal={() => { setModuleEditMode(false); setModuleEditData({}); setShowModulePopup(false); }}
                    mode={moduleEditMode ? "EDIT" : 'ADD'}
                    moduleData={moduleEditData}
                    changeInModule={changeInModule}
                />
            )}

            {showVideoPopup && (
                <SortVideos
                    renderVideos={(uid, uname) => getTrainingModules(uid, uname)}
                    hideModal={hideVideoPopup}
                    moduleData={moduleEditData}
                />
            )}

            {moduleListPopup && (
                <SortModules
                    renderVideos={(uid, uname) => getTrainingModules(uid, uname)}
                    title={'Module list'}
                    hideModal={hideModulePopup}
                    moduleData={trainingModuleData}
                />
            )}

            <Dialog open={deletePopup} onOpenChange={() => setDeletePopup(false)}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Delete Module</DialogTitle>
                        <DialogDescription>
                            Are you sure you want to delete this module?
                        </DialogDescription>
                    </DialogHeader>
                    {deleteModuleSuccessMsg && (
                        <p className="text-sm text-green-600">{deleteModuleSuccessMsg}</p>
                    )}
                    <DialogFooter>
                        <Button variant="outline" onClick={() => setDeletePopup(false)} disabled={deleteVideoLoader}>
                            No
                        </Button>
                        <Button variant="destructive" onClick={() => deleteModule(moduleId)} disabled={deleteVideoLoader}>
                            {deleteVideoLoader ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Deleting</> : 'Yes'}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
        : <Navigate replace to="/page-not-found" />
    );
}

export default AdminTraining;

